import {Component, Input, OnInit} from '@angular/core';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {LocationService} from "../../domain/services/location/location.service";
import {EnrollmentModel} from "../../domain/models/enrollment.model";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {RouterModule} from "@angular/router";
import {MatSelectModule} from "@angular/material/select";
import {CommonModule} from "@angular/common";
import {EnrollmentComponent} from "../enrollment-request/EnrollmentComponent";

@Component({
  selector: 'app-mgmt-company-address',
  standalone: true,
    imports: [
      ReactiveFormsModule,
      MatButtonModule,
      MatFormFieldModule,
      MatIconModule,
      FormsModule,
      RouterModule,
      MatInputModule,
      MatSelectModule,
      CommonModule
    ],
  templateUrl: './mgmt-company-address.component.html',
  styleUrl: './mgmt-company-address.component.css'
})
export class MgmtCompanyAddressComponent implements OnInit, EnrollmentComponent {
  @Input() company: EnrollmentModel = {};
  addressInfoForm!: FormGroup;
  cities: any[] = [];
  states: any[] = [];
  countries: any[] = [];

  constructor(private fb: FormBuilder,
              private readonly locationService: LocationService){
  }

  ngOnInit(): void {
    this.buildForm(this.company);
    this.pullCatalogs();
  }

  private pullCatalogs() {
    this.locationService.getCountryList().subscribe(countryList => {
      this.countries = countryList;
    })
    this.locationService.getStateList().subscribe(states => {
      this.states = states;
    });
  }

  private buildForm(info: EnrollmentModel): void {
    this.addressInfoForm = this.fb.group({
      street: [info.streetAddress ?? '', Validators.required],
      aptUnitSuite: [info.aptUnitSuite ?? ''],
      city: [info.city ?? '', Validators.required],
      state: [info.stateId ?? '', Validators.required],
      zip: [info.zipCode ?? '', [Validators.required, Validators.pattern(/^\d{5}(?:-\d{4})?$/)]],
      note: [info.note ?? ''],
      businessLegalName: [info.businessLegalName?? null, Validators.required],
      businessDbaName: [info.businessDbaName?? null],
      webSiteUrl: [info.webSiteUrl?? null, [
        Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)]],
      printedName: [{value: info.printedName?? null, disabled:true}],
    });
  }

  getUpdatedEnrollment(): EnrollmentModel {
    const formValues = this.addressInfoForm.value;
    return {
      streetAddress: formValues.street,
      aptUnitSuite: formValues.aptUnitSuite,
      city: formValues.city,
      stateId: formValues.state,
      zipCode: formValues.zip,
      note: formValues.note,
      businessLegalName: formValues.businessLegalName,
      businessDbaName: formValues.businessDbaName,
      webSiteUrl: formValues.webSiteUrl,
      printedName: formValues.printedName
    };
  }

  isFormValid(): boolean {
    return this.addressInfoForm.valid;
  }

  raiseFormValidations(): void {
    this.addressInfoForm.markAllAsTouched();
  }

}
